import { useState, useEffect, PointerEvent } from "react";
import I18n from "common/i18n";

// ピースプレビュー専用のリセットボタン。PreviewStartBtn と同形の pill で
// 橙赤ファミリ（.alpha .btn-danger: #fc6560 / 影 #b64643）。
export const PreviewResetBtn = ({ scale, reset }: { scale: number; reset: () => void }) => {
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setDisable(false);
  }, []);

  const handleReset = (e: PointerEvent) => {
    if (!disable && e.isPrimary) {
      setDisable(true);
      reset();
    }
  };

  return (
    <div
      className="flex-col-el flex-center origin-bottom pointer-events-auto"
      style={{ transform: `scale(${scale})`, marginBottom: 24 * scale }}
    >
      <button
        type="button"
        onPointerDown={handleReset}
        aria-label={I18n.t("MSG_COURSE_GAME_RESET_BTN")}
        className="type-inherit-font flex-row-el items-center justify-center box-border gap-3 h-20 pl-6 pr-8 rounded-full border-none cursor-pointer select-none bg-gradient-to-b from-[#ff8a85] to-[#e84e49] shadow-[0_6px_0_0_#b64643,0_12px_20px_rgba(182,70,67,0.35)] transition-all duration-100 active:translate-y-[6px] active:shadow-[0_0_0_0_#b64643,0_3px_8px_rgba(182,70,67,0.3)]"
      >
        <span className="flex-col-center w-12 h-12 rounded-full bg-white shadow-[inset_0_-2px_3px_rgba(0,0,0,0.08)]">
          <span className="material-symbols-outlined material-symbols-filled type-title text-[#e84e49]">
            refresh
          </span>
        </span>
        <p className="type-text type-title text-white whitespace-nowrap drop-shadow-[0_2px_0_rgba(0,0,0,0.12)]">
          {I18n.t("MSG_COURSE_GAME_RESET_BTN")}
        </p>
      </button>
    </div>
  );
};
